/**
 * The room-metadata key under which visitor mode state is stored/broadcast.
 */
export const VISITORS_METADATA_KEY = 'visitors';
/**
 * Visitor toggle mode: only guests who join after the toggle become visitors.
 * Existing main-room guests are left untouched.
 */
export const VISITOR_MODE_NEW_GUESTS_ONLY = 'new-guests-only';
/**
 * Visitor toggle mode: existing non-moderator guests are moved into visitor mode
 * and future guests also join as visitors.
 */
export const VISITOR_MODE_MOVE_CURRENT_GUESTS = 'move-current-guests';
/**
 * Server-relayed message telling the visitors of a room that visitor mode has
 * been turned off, so they can rejoin the main meeting as ordinary guests.
 * Prosody sends it to every connected visitor node (see mod_visitors).
 */
export const VISITOR_MODE_DISABLED = 'visitor-mode-disabled';
